
// import {
//   buildSalarySlip,
//   buildPaidHistory,
//   getPreviousMonth,
//   MONTH_NAMES,
// } from "./HrmData";

// const pad2 = (n) => String(n).padStart(2, "0");

// // ─── Date range label, e.g. "01 Jun, 2026 - 30 Jun, 2026" ──────────────────
// export const formatPrintDateRange = (year, month) => {
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
//   const shortMonth = MONTH_NAMES[month].slice(0, 3);
//   return `01 ${shortMonth}, ${year} - ${pad2(daysInMonth)} ${shortMonth}, ${year}`;
// };

// // ─── Number → Indian words, e.g. 320000 -> "Three Lakh Twenty Thousand Rupees"
// const ONES = [
//   "",
//   "One",
//   "Two",
//   "Three",
//   "Four",
//   "Five",
//   "Six",
//   "Seven",
//   "Eight",
//   "Nine",
//   "Ten",
//   "Eleven",
//   "Twelve",
//   "Thirteen",
//   "Fourteen",
//   "Fifteen",
//   "Sixteen",
//   "Seventeen",
//   "Eighteen",
//   "Nineteen",
// ];
// const TENS = [
//   "",
//   "",
//   "Twenty",
//   "Thirty",
//   "Forty",
//   "Fifty",
//   "Sixty",
//   "Seventy",
//   "Eighty",
//   "Ninety",
// ];

// const twoDigitWords = (n) => {
//   if (n < 20) return ONES[n];
//   const t = Math.floor(n / 10);
//   const o = n % 10;
//   return `${TENS[t]}${o ? " " + ONES[o] : ""}`;
// };

// const threeDigitWords = (n) => {
//   const h = Math.floor(n / 100);
//   const rest = n % 100;
//   return `${h ? ONES[h] + " Hundred" : ""}${h && rest ? " " : ""}${rest ? twoDigitWords(rest) : ""}`;
// };

// /** Indian numbering: crore / lakh / thousand / hundred */
// export const numberToWordsIndian = (num) => {
//   const n = Math.round(Math.abs(num));
//   if (n === 0) return "Zero Rupees";

//   const crore = Math.floor(n / 10000000);
//   const lakh = Math.floor((n % 10000000) / 100000);
//   const thousand = Math.floor((n % 100000) / 1000);
//   const hundred = n % 1000;

//   const parts = [];
//   if (crore) parts.push(`${threeDigitWords(crore)} Crore`);
//   if (lakh) parts.push(`${threeDigitWords(lakh)} Lakh`);
//   if (thousand) parts.push(`${threeDigitWords(thousand)} Thousand`);
//   if (hundred) parts.push(threeDigitWords(hundred));

//   return `${parts.join(" ").trim()} Rupees`;
// };

// // ─── Mon → Sun calendar grid (unlike the on-screen Sun → Sat grid) ─────────
// /** Returns an array of week-rows; each row is 7 cells of `date` string or null. */
// export const buildMonthGridPrint = (year, month) => {
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
//   const firstWeekday = new Date(year, month, 1).getDay(); // 0=Sun..6=Sat
//   const startOffset = (firstWeekday + 6) % 7; // convert to 0=Mon..6=Sun

//   const cells = [];
//   for (let i = 0; i < startOffset; i++) cells.push(null);
//   for (let day = 1; day <= daysInMonth; day++) {
//     cells.push(`${year}-${pad2(month + 1)}-${pad2(day)}`);
//   }
//   while (cells.length % 7 !== 0) cells.push(null);

//   const rows = [];
//   for (let i = 0; i < cells.length; i += 7) rows.push(cells.slice(i, i + 7));
//   return rows;
// };

// export const PRINT_WEEK_HEADS = [
//   "Mon",
//   "Tue",
//   "Wed",
//   "Thu",
//   "Fri",
//   "Sat",
//   "Sun",
// ];

// /** Short status label used inside each print-calendar day cell. */
// export const STATUS_SHORT = {
//   Present: "Present",
//   Absent: "Absent",
//   "Half-Day": "Half Day",
//   Leave: "Leave",
// };

// export const STATUS_LEGEND = [
//   { code: "P", label: "Present" },
//   { code: "A", label: "Absent" },
//   { code: "HD", label: "Half Day" },
//   { code: "WO", label: "Weekly Off" },
//   { code: "PCO", label: "Present (Comp Off)" },
//   { code: "HDCO", label: "Half Day (Comp Off)" },
//   { code: "L", label: "Leave" },
//   { code: "H", label: "Holiday" },
// ];


// export const buildPrintSalarySlip = (employee, records, year, month) => {
//   const slip = buildSalarySlip(employee, records, year, month);
//   const { year: prevYear, month: prevMonth } = getPreviousMonth(year, month);

//   const priorHistory = buildPaidHistory(employee, records, prevYear, prevMonth);
//   const previousBalance =
//     prevYear < new Date(employee.joiningDate).getFullYear() ||
//     (prevYear === new Date(employee.joiningDate).getFullYear() &&
//       prevMonth < new Date(employee.joiningDate).getMonth())
//       ? 0
//       : priorHistory.totalPaid;

//   const netPayable = slip.netPay + previousBalance;

//   return {
//     ...slip,
//     dateRangeLabel: formatPrintDateRange(year, month),
//     earningsLabel: `Present${"\u20B9"}${slip.dailyRate.toFixed(2)} x ${slip.payableDays} Days`,
//     previousBalance,
//     netPayable,
//     netPayableWords: numberToWordsIndian(netPayable),
//     overtimeMins: employee.overtimeMins ?? 0,
//     fineMins: employee.fineMins ?? 0,
//   };
// };



import {
  buildSalarySlip,
  buildPaidHistory,
  getPreviousMonth,
  MONTH_NAMES,
} from "./HrmData";

const pad2 = (n) => String(n).padStart(2, "0");

// ─── Date range label, e.g. "01 Jun, 2026 - 30 Jun, 2026" ──────────────────
export const formatPrintDateRange = (year, month) => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const shortMonth = MONTH_NAMES[month].slice(0, 3);
  return `01 ${shortMonth}, ${year} - ${pad2(daysInMonth)} ${shortMonth}, ${year}`;
};

// ─── Number → Indian words, e.g. 320000 -> "Three Lakh Twenty Thousand Rupees"
const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];
const TENS = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

const twoDigitWords = (n) => {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return `${TENS[t]}${o ? " " + ONES[o] : ""}`;
};

const threeDigitWords = (n) => {
  const h = Math.floor(n / 100);
  const rest = n % 100;
  return `${h ? ONES[h] + " Hundred" : ""}${h && rest ? " " : ""}${rest ? twoDigitWords(rest) : ""}`;
};

/** Indian numbering: crore / lakh / thousand / hundred */
export const numberToWordsIndian = (num) => {
  const n = Math.round(Math.abs(num));
  if (n === 0) return "Zero Rupees";

  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const hundred = n % 1000;

  const parts = [];
  if (crore) parts.push(`${threeDigitWords(crore)} Crore`);
  if (lakh) parts.push(`${threeDigitWords(lakh)} Lakh`);
  if (thousand) parts.push(`${threeDigitWords(thousand)} Thousand`);
  if (hundred) parts.push(threeDigitWords(hundred));

  return `${parts.join(" ").trim()} Rupees`;
};

// ─── Mon → Sun calendar grid (unlike the on-screen Sun → Sat grid) ─────────
/** Returns an array of week-rows; each row is 7 cells of `date` string or null. */
export const buildMonthGridPrint = (year, month) => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstWeekday = new Date(year, month, 1).getDay(); // 0=Sun..6=Sat
  const startOffset = (firstWeekday + 6) % 7; // convert to 0=Mon..6=Sun

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let day = 1; day <= daysInMonth; day++) {
    cells.push(`${year}-${pad2(month + 1)}-${pad2(day)}`);
  }
  while (cells.length % 7 !== 0) cells.push(null);

  const rows = [];
  for (let i = 0; i < cells.length; i += 7) rows.push(cells.slice(i, i + 7));
  return rows;
};

export const PRINT_WEEK_HEADS = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];

/**
 * Date-picker-style month grid: every cell always has a real day number —
 * trailing days of the previous month and leading days of the next month
 * are included (and flagged `inMonth: false`) instead of left blank, the
 * same way a normal calendar widget pads out its first/last week.
 * Returns an array of week-rows; each row has 7 cells:
 *   { iso: "YYYY-MM-DD", day: number, inMonth: boolean }
 */
export const buildMonthGridWithAdjacent = (year, month) => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstWeekday = new Date(year, month, 1).getDay(); // 0=Sun..6=Sat
  const startOffset = (firstWeekday + 6) % 7; // convert to 0=Mon..6=Sun

  const prevMonthDate = new Date(year, month, 0); // last day of previous month
  const daysInPrevMonth = prevMonthDate.getDate();
  const prevYear = prevMonthDate.getFullYear();
  const prevMonthIdx = prevMonthDate.getMonth();

  const cells = [];

  for (let i = startOffset - 1; i >= 0; i--) {
    const day = daysInPrevMonth - i;
    cells.push({
      iso: `${prevYear}-${pad2(prevMonthIdx + 1)}-${pad2(day)}`,
      day,
      inMonth: false,
    });
  }

  for (let day = 1; day <= daysInMonth; day++) {
    cells.push({
      iso: `${year}-${pad2(month + 1)}-${pad2(day)}`,
      day,
      inMonth: true,
    });
  }

  let nextDay = 1;
  const nextMonthDate = new Date(year, month + 1, 1);
  const nextYear = nextMonthDate.getFullYear();
  const nextMonthIdx = nextMonthDate.getMonth();
  while (cells.length % 7 !== 0) {
    cells.push({
      iso: `${nextYear}-${pad2(nextMonthIdx + 1)}-${pad2(nextDay)}`,
      day: nextDay,
      inMonth: false,
    });
    nextDay += 1;
  }

  const rows = [];
  for (let i = 0; i < cells.length; i += 7) rows.push(cells.slice(i, i + 7));
  return rows;
};

/** Short status label used inside each print-calendar day cell. */
export const STATUS_SHORT = {
  Present: "Present",
  Absent: "Absent",
  "Half-Day": "Half Day",
  Leave: "Leave",
};

export const STATUS_LEGEND = [
  { code: "P", label: "Present" },
  { code: "A", label: "Absent" },
  { code: "HD", label: "Half Day" },
  { code: "WO", label: "Weekly Off" },
  { code: "PCO", label: "Present (Comp Off)" },
  { code: "HDCO", label: "Half Day (Comp Off)" },
  { code: "L", label: "Leave" },
  { code: "H", label: "Holiday" },
];

// ─── Full print-ready salary slip: earnings + carried-forward balance ──────
/**
 * `previousBalance` mirrors the PDF's "Previous Month Closing Balance": the
 * total net pay for every month from the employee's joining date up to (but
 * not including) the selected month — i.e. everything not yet reflected in
 * this month's earnings line. Since this app doesn't track a separate
 * "marked paid" flag inside the modal, this is the full historical net pay,
 * the same way buildPaidHistory already totals it.
 */
export const buildPrintSalarySlip = (employee, records, year, month) => {
  const slip = buildSalarySlip(employee, records, year, month);
  const { year: prevYear, month: prevMonth } = getPreviousMonth(year, month);

  const priorHistory = buildPaidHistory(employee, records, prevYear, prevMonth);
  const previousBalance =
    prevYear < new Date(employee.joiningDate).getFullYear() ||
    (prevYear === new Date(employee.joiningDate).getFullYear() &&
      prevMonth < new Date(employee.joiningDate).getMonth())
      ? 0
      : priorHistory.totalPaid;

  const netPayable = slip.netPay + previousBalance;

  return {
    ...slip,
    dateRangeLabel: formatPrintDateRange(year, month),
    earningsLabel: `Present${"\u20B9"}${slip.dailyRate.toFixed(2)} x ${slip.payableDays} Days`,
    previousBalance,
    netPayable,
    netPayableWords: numberToWordsIndian(netPayable),
    overtimeMins: employee.overtimeMins ?? 0,
    fineMins: employee.fineMins ?? 0,
  };
};
